// Angular
import { Component, HostBinding, OnInit, Input } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
// RxJS
import { filter } from 'rxjs/operators';
// Translate
import { TranslationService } from '../../../../../core/_base/layout';
import { AuthService } from '../../../../../core/auth/_services/auth.service';
import { Item } from '@app/models/item.inferface';


@Component({
	selector: 'kt-my-leader',
	templateUrl: './my-leader.component.html',
	styleUrls: ['./my-leader.component.scss']
})
export class MyLeaderComponent implements OnInit {
	// Public properties
	@HostBinding('class') classes = '';
	@Input() iconType: '' | 'brand';

	// Set bg image path
	@Input() bgImage: string;

	@Input() skin: 'light' | 'dark' = 'light';

	@Input() myLeaders: string[] = [];

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 */
	constructor(
		private translationService: TranslationService,
		private router: Router,
		private _auth: AuthService
	) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		const userLanguage = this._auth.currentUserLanguage || 'esAR';
	}

	backGroundStyle(): string {
		if (!this.bgImage) {
			return 'none';
		}

		return 'url(' + this.bgImage + ')';
	}
}
